import cn from 'classnames';

export function editorChromeHeaderClassName(className) {
  return cn(
    'fixed top-0 left-0 right-0 h-header bg-neutral-2 border-b border-neutral-4 z-50 flex items-center justify-between px-8',
    className,
  );
}

export function editorChromeSidebarAsideClassName(sidebarCollapsed, className) {
  return cn(
    'fixed left-0 top-header bottom-0 flex flex-col bg-neutral-1 border-r border-neutral-4 overflow-y-auto z-40 transition-[width] duration-200',
    sidebarCollapsed ? 'w-20 p-2' : 'w-sidebar p-4',
    'max-[1140px]:w-20 max-[1140px]:p-2',
    className,
  );
}

export function editorChromeMainClassName(sidebarCollapsed, className) {
  return cn(
    'pt-header min-h-screen bg-background transition-[margin-left] duration-200',
    sidebarCollapsed ? 'ml-20' : 'ml-sidebar max-[1140px]:ml-20',
    className,
  );
}

export function editorChromeStickyBarClassName(sidebarCollapsed, className) {
  return cn(
    'sticky top-header right-0 h-subheader bg-white border-b border-neutral-4 z-30 flex items-start justify-between py-8 pr-8 pl-10 shadow-sm transition-[left] duration-200',
    sidebarCollapsed ? 'left-20' : 'left-sidebar max-[1140px]:left-20',
    className,
  );
}

const EditorChromeLayout = ({
  header,
  sidebar,
  sidebarCollapsed = false,
  children,
  shellClassName,
  mainClassName,
}) => {
  return (
    <div className={cn('min-h-screen bg-neutral-2', shellClassName)}>
      {header}
      {sidebar}
      <main className={editorChromeMainClassName(sidebarCollapsed, mainClassName)}>{children}</main>
    </div>
  );
};

export default EditorChromeLayout;
